export const STATUS_OPTIONS = [
  { value: "neu", label: "Neu" },
  { value: "vorgemerkt", label: "Vorgemerkt" },
  { value: "kontaktiert", label: "Kontaktiert" },
  { value: "qualifiziert", label: "Qualifiziert" },
  { value: "kein_interesse", label: "Kein Interesse" },
  { value: "ausgeschlossen", label: "Ausgeschlossen" },
];

export const STATUS_STYLE = {
  neu: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  vorgemerkt: "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300",
  kontaktiert: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  qualifiziert: "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300",
  kein_interesse: "bg-gray-200 text-gray-600 dark:bg-gray-800 dark:text-gray-400",
  ausgeschlossen: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "2-digit" }) : "–";
